import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.721 5.66L18.341 17.28C19.6605 15.6986 20.3408 13.6808 20.2481 11.6233C20.1554 9.56573 19.2965 7.61728 17.8401 6.16092C16.3837 4.70455 14.4353 3.8456 12.3777 3.75291C10.3202 3.66021 8.30242 4.34048 6.721 5.66ZM17.281 18.34L5.661 6.72C4.34148 8.30142 3.66121 10.3192 3.75391 12.3767C3.8466 14.4343 4.70555 16.3827 6.16192 17.8391C7.61828 19.2955 9.56673 20.1544 11.6243 20.2471C13.6818 20.3398 15.6996 19.6595 17.281 18.34ZM5.106 5.106C8.913 1.298 15.086 1.298 18.894 5.106C22.702 8.913 22.702 15.086 18.894 18.894C15.087 22.702 8.914 22.702 5.106 18.894C1.298 15.087 1.298 8.914 5.106 5.106Z"
        fill={colorValue}
      />
    </svg>
  );
};
